module.exports = __webpack_public_path__ + "img/tq2.b275fa39.png";